import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Material UI
import {Grid} from "@mui/material";

// Components
import CustomButton from "components/CustomButton";

// Local component
import RemoveFromTrolleyPopup from "./components/RemoveFromTrolleyPopup";

RemoveFromTrolleyAction.propTypes = {
    selectedWmsItem: PropTypes.object,
    handleCloseDrawer: PropTypes.func.isRequired,
    onRemoveFromTrolley: PropTypes.func,
};

function RemoveFromTrolleyAction({selectedWmsItem, handleCloseDrawer, onRemoveFromTrolley = () => {}}) {
    const [openRemoveFromTrolleyPopup, setOpenRemoveFromTrolleyPopup] = useState(false);


    if (!selectedWmsItem) {
        return null;
    }

    return (
        <Grid
            container
            spacing={2}
            direction={'column'}
        >
            <Grid item>
                <CustomButton
                    color={'red'}
                    variant={'contained'}
                    fullWidth={true}
                    thicker={true}
                    onClick={() => setOpenRemoveFromTrolleyPopup(true)}
                >
                    <FormattedMessage id='wms.myPickingMissions.popup.product.action.removeFromTrolley' />
                </CustomButton>
            </Grid>
            <RemoveFromTrolleyPopup
                wmsItem={selectedWmsItem}
                open={openRemoveFromTrolleyPopup}
                onRemove={() => {
                    setOpenRemoveFromTrolleyPopup(false)
                    handleCloseDrawer();
                    onRemoveFromTrolley();
                }}
                handleClose={() => {
                    setOpenRemoveFromTrolleyPopup(false)
                    handleCloseDrawer();
                }}
            />
        </Grid>
    );
}

export default RemoveFromTrolleyAction;
